window.Products.DeviceCase.GalaxyS7 = function() {
};
window.Products.DeviceCase.GalaxyS7.inherits(window.Products.DeviceCase.DeviceCase);
window.Products.DeviceCase.GalaxyS7.id = 52;
window.Products.DeviceCase.GalaxyS7.slug = 'galaxy-s7';

window.Products.DeviceCase.GalaxyS7.prototype.set3dProperties = function(modelViewer) {
	this.updateThreeTexture(modelViewer);
	modelViewer.object.position.y = -0.71;
	modelViewer.camera.position.z = 8;
};

window.Products.DeviceCase.GalaxyS7.prototype.setThreeControls = function(controls) {
	controls.minDistance = 3.4;
	controls.maxDistance = 4.4;
};